export default __webpack_public_path__ + "static/media/braintwo.f40c865c.png";